import script from "./used-policy-terminals.vue?vue&type=script&lang=ts&setup=true"
export * from "./used-policy-terminals.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__